import { BaseBloc } from '@core/utils/bloc';
import { BehaviorSubject } from 'rxjs';
import { LoadingState } from '@core/utils/repository/loading_state';
import { FrontEndAPI } from '@business/api/frontend';
import { PSearchRequest, FilteredHelpArticleResponse } from '@business/entities/frontend';
import { PaginatedController } from '@core/utils/paginated';

export class HomePageBloc extends BaseBloc {
  readonly data$ = new BehaviorSubject<FilteredHelpArticleResponse | null>(null);

  constructor(private readonly company: string, private readonly searchQuery: string) {
    super();
  }

  loading = new LoadingState();

  fetchFn = (query: PSearchRequest) => {
    return FrontEndAPI.filterArticles(query).pipe(this.loading.run({ refresh: query.page! > 1 }));
  };

  readonly paginated = new PaginatedController<FilteredHelpArticleResponse, string, PSearchRequest>(this.fetchFn, '', {
    page: 1,
    company: this.company,
    search: this.searchQuery,
  });
  readonly articles$ = this.paginated.items$;

  onInit() {
    return this.paginated.fetch();
  }
}
